import React from "react"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../../components/Common/ChartsDynamicColor"

const PieChart = ({ dataColors, data }) => {
  const PieApexChartColors = getChartColorsArray(dataColors)

  const rawData = [
    { label: "Above 90", val: data?.percent90 ?? "0.0", color: PieApexChartColors[0] || "#556ee6" },
    { label: "Above 80", val: data?.percent80_to_90 ?? "0.0", color: PieApexChartColors[1] || "#34c38f" },
    { label: "Above 65", val: data?.percent65_to_80 ?? "0.0", color: PieApexChartColors[2] || "#50a5f1" },
    { label: "Above 55", val: data?.percent55_to_65 ?? "0.0", color: PieApexChartColors[3] || "#f1b44c" },
    { label: "Above 33", val: data?.percent33_to_55 ?? "0.0", color: PieApexChartColors[4] || "#74788d" },
    { label: "Below 33", val: data?.percent0_to_33 ?? "0.0", color: PieApexChartColors[5] || "#f46a6a" },
  ]

  const series = rawData.map(item => Number(item.val) || 0)
  const total = series.reduce((acc, curr) => acc + curr, 0)
  const isAllZero = total === 0

  if (isAllZero) {
    const zeroOptions = {
      chart: {
        type: "donut",
        sparkline: { enabled: true },
      },
      stroke: { width: 0 },
      colors: ["#eaedf1"],
      tooltip: { enabled: false },
      dataLabels: { enabled: false },
      plotOptions: {
        pie: {
          donut: {
            size: "72%",
            labels: {
              show: true,
              name: { show: false },
              value: {
                show: true,
                fontSize: "16px",
                fontWeight: 600,
                color: "#74788d",
                formatter: () => "0%",
              },
              total: {
                show: true,
                label: "Total",
                fontSize: "16px",
                fontWeight: 600,
                color: "#74788d",
                formatter: () => "0%",
              },
            },
          },
        },
      },
    }

    return (
      <div className="d-flex flex-wrap align-items-center justify-content-around py-2">
        <div style={{ width: "140px", height: "140px" }} className="d-flex align-items-center justify-content-center">
          <ReactApexChart options={zeroOptions} series={[1]} type="donut" width="140" height="140" />
        </div>
        <div className="ps-2">
          {rawData.map((item, idx) => (
            <div key={idx} className="d-flex align-items-center justify-content-between mb-1" style={{ minWidth: "160px" }}>
              <div className="d-flex align-items-center">
                <span
                  style={{
                    display: "inline-block",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: item.color,
                    marginRight: "8px",
                  }}
                />
                <span className="font-size-12 text-muted">{item.label}</span>
              </div>
              <span className="font-size-12 fw-medium text-dark ms-3">{item.val}%</span>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const options = {
    chart: {
      width: 300,
      type: "pie",
    },
    labels: rawData.map(item => ` ${item.label} - ${item.val}%`),
    colors: rawData.map(item => item.color),
    legend: {
      show: true,
      position: "right",
      horizontalAlign: "center",
      verticalAlign: "middle",
      floating: false,
      fontSize: "13px",
      offsetX: 0,
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  }

  return (
    <ReactApexChart options={options} series={series} type="pie" height="260" />
  )
}

export default PieChart
